import { LOAD_ALBUM, ILoadAlbum } from '../actions/albumAction';

export default function albumReducer(
  state: ILoadAlbum | any = {},
  action: any
): object {
  switch (action.type) {
    case LOAD_ALBUM:
      return { ...state, ...action.loadAlbumValues };

    default:
      return state;
  }
}
